import Swiper, { Lazy, Navigation, Pagination } from "swiper";
import Common from "./common";

const Lightbox = {
  swiper: null,

  init() {
    this.events();
  },

  events() {
    // Single image.
    $("[data-lightbox]").on("click", (e) => {
      const toggle = $(e.currentTarget);
      const image = toggle.data("lightbox");

      Lightbox.create([image]);
    });

    // Photo gallery.
    $(".gallery-lightbox").on("click", (e) => {
      const btnEl = $(e.currentTarget);

      let images = btnEl.closest("[data-gallery]").data("gallery");

      Lightbox.create(images, btnEl.parent().index());
    });

    $("body").on("click", ".lightbox__close", () => {
      Lightbox.close();
    });

    $("body").on("keyup", (e) => {
      if ("Escape" == e.key) {
        Lightbox.close();
      }
    });
  },

  close() {
    if (Common.scrollbar) {
      Common.scrollbar.updatePluginOptions("modal", { open: false });
    }

    $("html").removeClass("no-scroll");
    $(".lightbox").removeClass("open");

    if (this.swiper) {
      this.swiper.destroy();
    }
  },

  create(images, offset = 0) {
    let slidesHtml = "";

    images.forEach((image) => {
      slidesHtml += `<div class="swiper-slide">
        <div class="lightbox__slide">
          <img class="lightbox__slide-img swiper-lazy"
            data-src="${image.src}"
            alt="${image.alt}"
          >
        </div>
      </div>`;
    });

    if (!$("#lightbox").length) {
      const lightboxHtml = `<div id="lightbox" class="lightbox">
        <div class="container container--large">
          <div class="lightbox__inner">
            <div class="lightbox__header">
              <a href="#" class="btn btn-icon btn-icon--light lightbox__download" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="21.5" height="21.5" viewBox="0 0 21.5 21.5"><path d="M7.75,21.5c-2.77,0-4.647-.586-5.9-1.845S0,16.52,0,13.75v-6C0,4.98.586,3.1,1.845,1.845S4.98,0,7.75,0h4.98a.741.741,0,0,1,.134.009h0l.012,0,.013,0h0a.75.75,0,0,1,.284.121h0l.014.01h0l.013.009,0,0,.012.008,0,0,.009.008.005,0,.009.008,0,0,.01.009,0,0L13.28.22l8,8,.012.012,0,0,.007.007,0,.005.006.007,0,.005a.024.024,0,0,1,.006.007l.011.013,0,0,.008.01h0a.744.744,0,0,1,.155.455v5c0,2.77-.586,4.647-1.845,5.9S16.52,21.5,13.75,21.5ZM2.905,2.905c-.958.959-1.4,2.5-1.4,4.845v6c0,2.346.446,3.885,1.4,4.845S5.4,20,7.75,20h6c2.346,0,3.885-.446,4.845-1.4S20,16.1,20,13.75V9.5H16.75C13.332,9.5,12,8.168,12,4.75V1.5H7.75C5.4,1.5,3.864,1.947,2.905,2.905ZM13.5,4.75c0,2.581.668,3.25,3.25,3.25h2.19L13.5,2.561ZM7.519,16.25H7.4l-.008,0H7.38l-.009,0-.008,0-.011,0-.007,0-.012,0-.005,0-.014,0h0l-.016,0h0a.745.745,0,0,1-.325-.192l-2-2a.75.75,0,0,1,1.061-1.06l.719.719V9.5a.75.75,0,0,1,1.5,0v4.19l.72-.72a.75.75,0,0,1,1.06,1.06l-2,2-.013.014-.007.006L8,16.055l-.011.01,0,0-.012.01h0a.763.763,0,0,1-.184.112h0l-.015.006h0l-.013.005-.006,0-.011,0-.007,0-.009,0-.01,0-.006,0-.013,0h0l-.014,0h0l-.014,0h0l-.015,0h0l-.015,0h0l-.014,0h0l-.014,0H7.519Z" transform="translate(0 0)" fill="#fff"/></svg>
                <span>Download</span>
              </a>

              <div class="lightbox__caption">
                <p class="lightbox__caption-inner caption text-center"></p>
              </div>

              <button class="btn btn-icon btn-icon--light lightbox__close" aria-label="Close lightbox">
                <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51"><path d="M0,25.5A25.5,25.5,0,1,1,25.5,51,25.5,25.5,0,0,1,0,25.5ZM16.159,3.386A24.084,24.084,0,1,0,25.5,1.5,23.936,23.936,0,0,0,16.159,3.386ZM31.97,33.03,25.5,26.561,19.031,33.03a.75.75,0,0,1-1.061-1.06l6.47-6.47-6.47-6.469a.75.75,0,0,1,1.061-1.061L25.5,24.44l6.47-6.47a.75.75,0,0,1,1.06,1.061L26.561,25.5l6.469,6.47a.75.75,0,1,1-1.06,1.06Z" fill="#fff"/></svg>
              </button>
            </div>

            <div class="lightbox__body">
              <div class="swiper lightbox-swiper">
                <div class="swiper-wrapper">${slidesHtml}</div>
              </div>

              <button class="swiper-nav swiper-nav--prev">
                <svg xmlns="http://www.w3.org/2000/svg" width="44.5" height="31.5" viewBox="0 0 44.5 31.5"><path d="M15.22,31.28l-15-15-.013-.013L.2,16.261l-.007-.008-.007-.008L.182,16.24l-.008-.009,0,0-.008-.01,0,0L.151,16.2l0,0L.14,16.186l0,0L.13,16.171l0,0-.007-.01,0-.006-.006-.009,0-.007,0-.008L.1,16.118l0-.006L.087,16.1l0,0a.75.75,0,0,1,0-.7l0,0,.006-.012,0-.006L.1,15.373l0-.008,0-.007.006-.009,0-.006.007-.01,0,0,.008-.011,0,0L.148,15.3l0,0,.008-.01,0,0,.008-.01,0,0,.008-.009.005-.006.007-.008L.2,15.239l.006-.006L.22,15.22l15-15a.75.75,0,0,1,1.06,1.061L2.561,15H43.75a.75.75,0,0,1,0,1.5H2.561l13.72,13.72a.75.75,0,1,1-1.06,1.061Z" transform="translate(0 0)" fill="#fff"/></svg>
              </button>
              <button class="swiper-nav swiper-nav--next">
                <svg xmlns="http://www.w3.org/2000/svg" width="44.5" height="31.5" viewBox="0 0 44.5 31.5"><path d="M29.28,31.28l15-15,.013-.013.007-.006.007-.008.007-.008,0-.005.008-.009h0l.008-.01h0l.015-.021h0l.011-.014h0l.01-.015h0l.007-.01v-.006l.006-.009v-.015l.017-.013v-.006l.013-.012h0a.75.75,0,0,0,0-.7h0l-.006-.012v-.006l-.007-.009v-.015l-.006-.009v-.006l-.007-.01h0l-.008-.011h0l-.027-.022h0l-.008-.01h0l-.008-.01h0l-.008-.009,0-.006-.007-.008-.016-.018-.006-.006-.014-.013-15-15a.75.75,0,1,0-1.06,1.061L41.939,15H.75a.75.75,0,0,0,0,1.5H41.939L28.219,30.22a.75.75,0,1,0,1.06,1.061Z" transform="translate(0 -0.001)" fill="#fff"/></svg>
              </button>
            </div>
            <div class="lightbox__footer">
              <div class="swiper-pagination caption"></div>

              <div class="lightbox__author">
                <p class="lightbox__author-inner caption text-center"></p>
              </div>
            </div>
          </div>
        </div>
      </div>`;

      $("body").append(lightboxHtml);
    } else {
      $("#lightbox .swiper-wrapper").html(slidesHtml);
    }

    const lightboxEl = $("#lightbox");

    this.swiper = new Swiper(".lightbox-swiper", {
      initialSlide: offset,
      watchSlidesProgress: true,
      modules: [Lazy, Pagination, Navigation],
      loop: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
      },
      pagination: {
        el: lightboxEl.find(".swiper-pagination")[0],
        type: "fraction",
      },
      navigation: {
        prevEl: lightboxEl.find(".swiper-nav--prev")[0],
        nextEl: lightboxEl.find(".swiper-nav--next")[0],
      },
      on: {
        init() {
          // Add image info on init
          const currImage = images[offset];
          Lightbox.showImageData(currImage);

          if (Common.scrollbar) {
            Common.scrollbar.updatePluginOptions("modal", { open: true });
          }

          // Show lightbox
          $("html").addClass("no-scroll");
          $(".lightbox").addClass("open");
        },
      },
    });

    // On slide change update info
    this.swiper.on("slideChange", (swiper) => {
      const currImage = images[swiper.realIndex];

      Lightbox.showImageData(currImage);
    });
  },

  /**
   * Handle image info in lightbox
   */
  showImageData(image) {
    $(".lightbox__download").attr("href", image.src);
    $(".lightbox__caption-inner").text(image.desc);
    $(".lightbox__author-inner").text(image.caption);
  },
};

export default Lightbox;
